enum TooltipPlacement {
	Bottom = 'bottom',
	Left = 'left',
	Right = 'right',
	Top = 'top',
	BottomEnd = 'bottom-end',
	BottomStart = 'bottom-start',
	LeftEnd = 'left-end',
	LeftStart = 'left-start',
	RightEnd = 'right-end',
	RightStart = 'right-start',
	TopEnd = 'top-end',
	TopStart = 'top-start',
}

export default TooltipPlacement;
